import type { Language } from './caseStudyData';
export function contactPath(language: Language, domain?: string, business?: string) {
  const path = `${language === 'ar' ? '/ar' : ''}/contact`;
  return domain ? `${path}?idea=${encodeURIComponent([domain, business].filter(Boolean).join('/'))}` : path;
}
